import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListTenant from './list/list';
import { TenantPage } from './view';

const TenantModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path=":id/*" element={<TenantPage />} />
        <Route path="/*" element={<ListTenant />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default TenantModule;
